import React from 'react'
import Header from'./header'
import Navbar from'./navbar';
import Body from'./body';


export default function home() {
  return (
    <>
    <Navbar class1="colorChange" class2="" c1="black" c2="white"/>
    <Header />
    <Body />
    
    </>
  )
}
